import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Button from '../../../../UniformComponents/Button'
import { renderField } from './utils'

@observer
class CreateEdit extends Component {
    constructor(props) {
        super(props)
        const { store, id } = this.props
        store.initEdit(parseInt(id, 10))
    }

    renderFields = () => {
        const { store } = this.props
        const { onBlur, register, unregister } = store

        return store.getFormFields().map((field) => (
            renderField(field, onBlur, register, unregister, store)
        ))
    }

    render() {
        const { store, history } = this.props
        const { save, isLoading, cancel } = store

        return (
            <Fragment>
                {!isLoading && this.renderFields()}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <Button
                        label={i18n.t('cancel')}
                        onClick={() => cancel(history)}
                        cssClass="tertiary regular"
                    />
                    <Button
                        label={i18n.t('save')}
                        onClick={() => save(history)}
                        cssClass="primary regular"
                    />
                </div>
            </Fragment>
        )
    }
}

export default CreateEdit
